import { styled, Box } from "@mui/material";

const FullScreenButtonRoot = styled(Box)(({ theme }) => ({
  width: 40,
  height: 40,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  pointerEvents: "all",
  zIndex: 5,
  position: "fixed",
  top: 5,
  left: 5,
  borderRadius: theme?.borderRadius?.small,
  overflow: "hidden",
  transition: "all ease-in-out 0.5s",
  opacity: 1,
  "&:before": {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: -1,
    background: theme?.palette?.companyColors?.accent,
    opacity: 1,
    borderRadius: theme?.borderRadius?.small,
  },
  [theme.breakpoints.up("xl")]: {
    left: "auto",
    right: 10,
    bottom: 10,
    top: "auto",
    width: 45,
    height: 45,
  },
  "&:hover": {
    "@media (hover: hover) and (pointer: fine)": {
      opacity: 1,
    },
  },
}));

const FullScreenButtonIcon = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  borderRadius: 0,
  minWidth: 0,
  padding: 0,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  margin: 0,
  transition: "all ease-in-out 0.5s",
  cursor: "pointer",
}));

export { FullScreenButtonRoot, FullScreenButtonIcon };
